
import Click from './sounds/Click';
import Progress from './sounds/Progress';
import Notification from './sounds/Notification';
import Error from './sounds/Error';
import CallForHelp from './sounds/CallForHelp';

class Sounds {
  constructor () {
    if (window.AudioContext || window.webkitAudioContext) {
      this.context = new (window.AudioContext || window.webkitAudioContext)();
      this.clickSound = new Click(this.context);
      this.progressSound = new Progress(this.context);
      this.notificationSound = new Notification(this.context);
      this.errorSound = new Error(this.context);
      this.callForHelpSound = new CallForHelp(this.context);
    }
  }

  click () { this.clickSound.play(); }
  progress () { this.progressSound.play(); }
  notification () { this.notificationSound.play(); }
  error () { this.errorSound.play(); }
  callForHelp () { this.callForHelpSound.toggle(); }
}

export default new Sounds();
